import { LayoutT } from 'business/definitions';
import { createContext, useContext } from 'react';

interface LayoutContextValue {
    layout?: LayoutT;
}

export const LayoutContext = createContext<LayoutContextValue>({
    layout: undefined,
});

export const useLayout = () => {
    const context = useContext(LayoutContext);
    if (context === undefined) {
        throw new Error('useLayout must be used within a LayoutProvider');
    }
    return context;
};
